export {
  computeJobFinancials,
  computeVariationFinancials,
  allocateMilestoneSplits,
  calculateJobPayoutSplit,
  computePayoutSplit,
  tradeGstCents,
  isTradeGstRegistered,
  isPayoutSettled,
  payoutStatusLabel,
  HOLDBACK_REFUNDED_PAYOUT_STATUS,
  DISPUTE_SETTLED_PAYOUT_STATUS,
  SETTLED_PAYOUT_STATUSES,
  SETTLED_PAYOUT_STATUSES_FILTER,
} from "../core/financial";

export type {
  JobFinancials,
  JobFinancialsResult,
  VariationFinancialsResult,
  MilestoneInput,
  MilestoneSplit,
  JobPayoutSplitInput,
  JobPayoutSplitResult,
  PayoutSplitResult,
  TradeCompanyGstInput,
} from "../core/financial";


/**
 * Computes the actual amount captured via Stripe from the client company for a variation in cents.
 * Stripe captures (Trade Net + Platform Commission) * 1.10 (GST). Client company markup is excluded.
 */
export function getVariationCapturedCents(variation?: {
  trade_amount_cents?: number | null;
  commission_amount_cents?: number | null;
  customer_total_cents?: number | null;
} | null): number {
  const tradeCents = variation?.trade_amount_cents ?? 0;
  const commissionCents = variation?.commission_amount_cents ?? 0;
  const subtotalCents = tradeCents + commissionCents;

  if (subtotalCents <= 0 && variation?.customer_total_cents) {
    return variation.customer_total_cents;
  }

  return subtotalCents + Math.round(subtotalCents * 0.10);
}

/**
 * Computes the client company's retained margin on a variation (inc GST) in cents.
 */
export function getVariationClientMarginCents(variation?: {
  markup_amount_cents?: number | null;
} | null): number {
  const markupCents = variation?.markup_amount_cents ?? 0;
  if (markupCents <= 0) return 0;
  return markupCents + Math.round(markupCents * 0.10);
}
